import { render, staticRenderFns } from "./aOwnerDetailRoomFee.vue?vue&type=template&id=67019eeb&scoped=true"
import script from "./aOwnerDetailRoomFee.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailRoomFee.vue?vue&type=script&lang=js"
import style0 from "./aOwnerDetailRoomFee.vue?vue&type=style&index=0&id=67019eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67019eeb",
  null
  
)

export default component.exports